export default __webpack_public_path__ + "static/media/XII_Old_White.0157b653.png";